import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark text-gray-500 py-6 px-3 border-t border-brand-accent/20" data-id="element-110">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-111">
        <div className="inline-block bg-brand-accent text-white font-black px-3 py-1 rounded-full mb-3 text-[10px] tracking-widest uppercase" data-id="element-112">
          ⚙️ KIT PROFE™
        </div>

        <p className="text-xs md:text-sm font-bold mb-2 max-w-xl text-gray-300" data-id="element-113">
          El sistema de materiales N°1 para docentes de programación de escuelas
          técnicas industriales en Argentina.
        </p>

        <p className="text-brand-accent font-black text-xs md:text-sm neon-glow" data-id="element-114">
          👉 Porque enseñar programación técnica en el laboratorio no debería
          costarte todos los domingos.
        </p>
      </div>
    </footer>;
}